import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const SpecialTransformation = () => (
  <QPhototModuleSubtopic
    title="Special transformation"
    videos={[
      "https://www.youtube.com/embed/10KwTwxnOEs",
      "https://www.youtube.com/embed/pSjaoGjyE7w"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_14.png"},
        {image:"/cvla_15.png"},
    ]}
    exampleVideos={[]}
  />
);

export default SpecialTransformation;
